// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3QWdJ","upload":"Small_upload__2miFR","imageWrap":"Small_imageWrap__qOe_y","removeBtn":"Small_removeBtn__3uXhD"};